module.exports = __webpack_public_path__ + "img/blu_monkey_naiharn_beach.55f0fef8.jpg";